import {
  Heading1Outlined,
  Heading2Outlined,
  Heading3Outlined,
  HorizontalRuleOutlined,
  ImageOutlined,
  VideoOutlined,
  TableOutlined,
  BulletListOutlined,
  OrderedListOutlined,
  TaskListOutlined,
  BlockquoteOutlined,
  CodeBlockOutlined,
  DateOutlined,
  InfoOutlined,
  SuccessOutlined,
  WarningOutlined,
  DangerOutlined,
  ToggleCardOutlined,
} from './ShortcutIcons';
import CommentIcon from './CommentIcon';
import EmojiIcon from './EmojiIcon';
import CoverIcon from './CoverIcon';
import LayoutIcon from './LayoutIcon';
import {
  TextIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  CodeBlockIcon,
  CodeIcon,
  BulletListIcon,
  NumberListIcon,
  TodoListIcon,
  QuoteIcon,
  TickOutlined,
  InlineCommentIcon,
} from './ToolbarIcons';
import { CopyOutlined, DeleteOutlined, ScissorOutlined, FileTextOutlined, AppstoreOutlined } from '@ant-design/icons';

export const ICONS_MAP = {
  heading_1_outlined: Heading1Outlined,
  heading_2_outlined: Heading2Outlined,
  heading_3_outlined: Heading3Outlined,
  bullet_list_outlined: BulletListOutlined,
  ordered_list_outlined: OrderedListOutlined,
  task_list_outlined: TaskListOutlined,
  blockquote_outlined: BlockquoteOutlined,
  codeblock_outlined: CodeBlockOutlined,
  horizontal_rule_outlined: HorizontalRuleOutlined,
  image_outlined: ImageOutlined,
  video_outlined: VideoOutlined,
  table_outlined: TableOutlined,
  date_outlined: DateOutlined,
  copy_outlined: CopyOutlined,
  cut_outlined: ScissorOutlined,
  delete_outlined: DeleteOutlined,
  info_calloutPanel: InfoOutlined,
  success_calloutPanel: SuccessOutlined,
  warning_calloutPanel: WarningOutlined,
  danger_calloutPanel: DangerOutlined,
  toggle_card_outlined: ToggleCardOutlined,
  document_outlined: FileTextOutlined,
  workspace_outlined: AppstoreOutlined,
};

export {
  TextIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  CodeBlockIcon,
  CodeIcon,
  BulletListIcon,
  NumberListIcon,
  TodoListIcon,
  QuoteIcon,
  TickOutlined,
  InlineCommentIcon,
  ToggleCardOutlined,
};
export { EmojiIcon, CoverIcon, CommentIcon, LayoutIcon };
